import React, { Fragment } from 'react';
import classNames from 'classnames';
import styles from './GA2RFValuesTableHeading.module.css';
import { IconLoader } from '../../../../../common/IconLoader';

function GA2RFValuesTableHeading({ className, style, children, sortable, toggleSort }) {
  return (
    <div
      role="columnheader"
      tabIndex="-1"
      className={classNames(styles.root, 'rt-th', className)}
      style={style}
      onClick={toggleSort}
    >
      {children}
      {sortable && (
        <Fragment>
          <img src={IconLoader.icon_table_sort} alt="" className={classNames(styles.sortIcon, styles.sortIconIdle)} />
          <img
            src={IconLoader.icon_table_sort_hover}
            alt=""
            className={classNames(styles.sortIcon, styles.sortIconHover)}
          />
        </Fragment>
      )}
    </div>
  );
}

export default GA2RFValuesTableHeading;
